import type { FamilyBilling } from '../shared/types';

/**
 * What the app shows for the family's access state (payments groundwork, 2026-10-12).
 * The state itself comes from the server (get-family → family.billing); with the payments switch
 * off (FEATURES.payments) nothing is ever shown.
 */

/** Paywall when the switch is on and access has ended. A missing state never locks anyone out. */
export function shouldShowPaywall(billing: FamilyBilling | null | undefined, paymentsOn: boolean): boolean {
  return paymentsOn && !!billing && billing.hasAccess === false;
}

export type BillingBanner = 'trial_ending' | 'payment_problem' | 'cancelling' | null;

/** A banner for grown-ups with admin access: trial ending soon, a failed payment, or a cancellation. */
export function billingBanner(billing: FamilyBilling | null | undefined, isAdmin: boolean, paymentsOn: boolean): BillingBanner {
  if (!paymentsOn || !billing || !isAdmin) return null;
  if (billing.state === 'trial' && billing.trialEndingSoon) return 'trial_ending';
  if (billing.state === 'grace') return 'payment_problem';
  if (billing.state === 'cancelling') return 'cancelling';
  return null;
}

/** Pages a grown-up with admin access can still open behind the paywall (to pay, leave or delete). */
export const PAYWALL_OPEN_PATHS = ['/subscription', '/settings', '/profile'];
